import HTML2IncDom from '../html/HTML2IncDom';
import IncrementalDomRenderer from '../IncrementalDomRenderer';

export {HTML2IncDom};
export default IncrementalDomRenderer;
